import SocketService from '@src/services/SocketService';

import { useMagicPenStore } from '@src/stores';
import { EMagicPenSockets, ICanvasObject } from '@src/types';

/* 
This service is used to fetch the Magic Pen annotations for the joined room.
It is used to fetch the annotations from the server and merge them with the local annotations (if any)
fetching was seperated from the useMagicPenIntegration hook to avoid pulling the full integration hook 
when the room is joined and to avoid circular dependencies.
*/

export const fetchMagicPenAnnotations = async (): Promise<void> => {
  try {
    // Request current canvas annotations for the joined room
    const response = await SocketService.request(EMagicPenSockets.FETCH_ANNOTATES, {});

    const annotations = (response?.annotations ?? []) as ICanvasObject[];
    if (annotations.length === 0) {
      return;
    }

    const { objects, setObjects } = useMagicPenStore.getState();
    const mergedMap = new Map<string, ICanvasObject>();

    // Initialize a map with the latest client state to preserve local edits
    objects.forEach((obj) => {
      if (obj?.id) {
        mergedMap.set(obj.id, obj);
      }
    });

    // Merge server payload over existing entries (this prevents objects duplications on canvas)
    annotations.forEach((annotation) => {
      if (!annotation?.id) return;
      const existing = mergedMap.get(annotation.id);
      mergedMap.set(annotation.id, existing ? { ...existing, ...annotation } : annotation);
    });

    setObjects(Array.from(mergedMap.values()));
  } catch (error) {
    console.error('Error fetching Magic Pen annotations:', error);
  }
};
